import React, { useEffect, useRef, useState } from 'react';

/**
 * Scroll-reveal wrapper.
 * Opacity 0 -> 1, translateY 16px -> 0, 500ms, ease-out-quart.
 * Respects `prefers-reduced-motion` via global CSS in index.css.
 */
export const Reveal = ({ as: As = 'div', delay = 0, className = '', children, ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          obs.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <As
      ref={ref}
      style={{
        opacity: shown ? 1 : 0,
        transform: shown ? 'translateY(0)' : 'translateY(16px)',
        transition: 'opacity 500ms cubic-bezier(0.22,1,0.36,1), transform 500ms cubic-bezier(0.22,1,0.36,1)',
        transitionDelay: `${delay}ms`,
      }}
      className={className}
      {...rest}
    >
      {children}
    </As>
  );
};

export default Reveal;
